import clsx from 'clsx';
import { ThumbsUp, Paragraph } from '@hungryroot/ui-kit';
import styles from './BinaryRatingRecipeScore.module.css';

interface Props {
  testid?: string;
  recipeScore: number | null;
  className?: string;
  displayPercentWrapperClassName?: string;
  numberOfRatings: number;
}

export function BinaryRatingRecipeScore(props: Props) {
  const {
    testid,
    recipeScore,
    className,
    numberOfRatings,
    displayPercentWrapperClassName,
  } = props;
  function renderRating() {
    if (
      recipeScore === null ||
      recipeScore === undefined ||
      recipeScore === 0
    ) {
      return (
        <span
          data-testid={`${testid}-just-added`}
          className={styles['display-percent-wrapper']}
        >
          <ThumbsUp />
          <Paragraph variant="caption">Just added</Paragraph>
        </span>
      );
    }

    function formatCompactNumber(number: number) {
      const formatter = Intl.NumberFormat('en', { notation: 'compact' });
      return formatter.format(number);
    }

    return (
      <Paragraph
        variant="caption"
        data-testid={`${testid}-show-rating`}
        className={clsx(
          styles['display-percent-wrapper'],
          styles.lowercase,
          displayPercentWrapperClassName
        )}
      >
        <ThumbsUp />
        <Paragraph variant="caption" as="span">
          {Math.round(recipeScore)}% ({formatCompactNumber(numberOfRatings)})
        </Paragraph>
      </Paragraph>
    );
  }

  return (
    <div className={className} data-testid={testid}>
      {renderRating()}
    </div>
  );
}
